/**
 * StudentRankingScreen — « Classement » de l'élève (route `ranking`), à la place de
 * `student/social/RankingTabScreen.js` quand l'espace élève est allumé.
 *
 * Patron A sans lecture à l'ouverture, comme l'ancien écran : les classements sont sur le compte
 * (`studentRankingViewModel`) ; la flèche relit le compte avec des classements frais
 * (`useStudentRankingData`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentRankingPage } from "../../../../../../design-system/student"
import { studentRankingViewModel } from "../../../../view-models/student/Game/studentRankingViewModel"
import { useStudentRankingData } from "./useStudentGameData"
import { useStudentRankingState } from "./useStudentGameState"

export function StudentRankingScreen() {
    useStudentRankingData()
    const vm = useSelector(studentRankingViewModel)
    const state = useStudentRankingState()

    return <StudentRankingPage boards={vm.boards} locked={vm.locked} loading={vm.loading} {...state} />
}
